import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Html,
  title: 'Html',
  category: ComponentCategory.General,
};
